import {EntityData, field, SearchModel} from "@fedelta-pos/data-client";
import {inject, Injectable, Injector} from "@angular/core";
import {AppLoginIdentificationMethod} from '../configuration/app-entity.model';

export class IdentitySearchData extends EntityData<IdentitySearchData> {
    @field email: string;
    @field mobilePhone: string;
    @field passwordSet: boolean;
    @field appId: number;
    @field appName: string;
    @field lastUsage: Date;
}

@Injectable()
export class IdentitySearchModel extends SearchModel<IdentitySearchData> {
    constructor() {
        console.log("--- IdentitySearchModel");
        super(inject(Injector));
    }

    retrieveByIdentity(identity: string, loginType: AppLoginIdentificationMethod, timeout?: number): Promise<IdentitySearchData> {
        this.filter = {
            "identity": identity,
            "loginType": loginType
        };
        return super.retrieve(timeout);
    }
}
